import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BranchEndpointService, MainPageEndpointsService } from '../common';
import { SoundPlaybackService, SoundBehaviourSetting, SoundSettings } from '../common/_services/sound-playback.service';
import { ApiBranchQueue } from '../common/_types/api.types';

interface BranchQueueSetting {
  id: string;
  name: string;
  forcedDisabled: boolean;
  loading: boolean;
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  branchQueues: BranchQueueSetting[] = [];
  isLoading = true;
  error: string | null = null;

  constructor(
    private router: Router,
    private mainPageEndpointsService: MainPageEndpointsService,
    public branchEndpointService: BranchEndpointService,
    private soundPlaybackService: SoundPlaybackService,
  ) {}

  get soundSettings(): SoundSettings {
    return this.soundPlaybackService.settings;
  }

  get isBranchQueueControlEnabled(): boolean {
    if (!this.branchEndpointService.details?.id) return false;
    return this.branchEndpointService.details?.featureFlags?.appsBranchQueueControl !== false;
  }

  ngOnInit(): void {
    this.loadBranchQueues();
  }

  public toggleSoundEnabled(): void {
    this.soundPlaybackService.toggleNewTokenSound();
  }

  public toggleServingSoundEnabled(): void {
    this.soundPlaybackService.toggleServingSound();
  }

  public setSoundBehaviour(behaviour: SoundBehaviourSetting): void {
    this.soundPlaybackService.setBehaviour(behaviour);
  }

  loadBranchQueues(): void {
    this.isLoading = true;
    this.error = null;

    this.mainPageEndpointsService.getQueuesData().subscribe({
      next: (response) => {
        this.branchQueues = response.data.map((queue: ApiBranchQueue) => ({
          id: queue.id,
          name: queue.attributes.name,
          forcedDisabled: queue.attributes.forcedDisabled || false,
          loading: false,
        }));
        this.isLoading = false;
      },
      error: (error) => {
        this.error = 'Failed to load branch queues';
        this.isLoading = false;
        console.error('Error loading branch queues:', error);
      },
    });
  }

  toggleQueue(queue: BranchQueueSetting): void {
    if (queue.loading) return;

    queue.loading = true;
    const newValue = !queue.forcedDisabled;

    this.branchEndpointService.updateBranchQueueForcedDisabled(queue.id, newValue).subscribe({
      next: () => {
        queue.forcedDisabled = newValue;
        queue.loading = false;
      },
      error: (error) => {
        queue.loading = false;
        console.error('Error updating branch queue:', error);
      },
    });
  }

  goBack(): void {
    this.router.navigate(['/main-page']);
  }
}
